import { render, staticRenderFns } from "./BuildTeams.vue?vue&type=template&id=fc9c6912&scoped=true"
import script from "./BuildTeams.vue?vue&type=script&lang=js"
export * from "./BuildTeams.vue?vue&type=script&lang=js"
import style0 from "./BuildTeams.vue?vue&type=style&index=0&id=fc9c6912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9c6912",
  null
  
)

export default component.exports